import { LoadingButton } from "@mui/lab";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSmsAssignmentsToMachineThunk,
  getSmsAssignmentsThunk,
  smsAssignmentsToMachineSelector,
} from "store/reducers/third_party/smsProviderAllocationSlice";
import AlertAllocationItem from "./AlertAllocationItem";

const AlertAllocationList = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { status } = useSelector((state) => state.smsAssignments);
  const smsAssignments = useSelector(smsAssignmentsToMachineSelector.selectAll);
  useEffect(() => {
    dispatch(getSmsAssignmentsThunk());
  }, []);

  return (
    <>
      {smsAssignments.length > 0 && (
        <Box
          sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1, mb: 2 }}
          padding={1}
        >
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {isSmallScreen ? "Name" : "Validation name"}
                  </TableCell>

                  <TableCell align="center">Code</TableCell>
                  <TableCell align="center">Type</TableCell>
                  <TableCell align="center">View auth</TableCell>
                  {/* <TableCell >&nbsp;</TableCell> */}
                  <TableCell sx={{ width: 30 }}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {smsAssignments.map((item) => (
                  <AlertAllocationItem key={item.id} item={item}/>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};

export default AlertAllocationList;
